// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__Q93Rh","Container":"Main_Container__ovCV9"};